
export function formatLastSynced(isoString, t) {
    if (!isoString) return null;
    const date = new Date(isoString);
    return date.toLocaleString();
  }